import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { IoMdClose } from "react-icons/io";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { HandleStatementUpload } from 'API/Limit_Topup_Checker/api';
import { useEffect } from 'react';


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};


export default function FileUploadDialog(props) {
    const [BankSelected, setBankSelected] = useState(null)
    const [file, setFile] = useState(null);
    const [statementDate, setStatementDate] = useState(formatDate(new Date()));

    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    };

    const handleChange = (event) => {
        if (event.target.value === "Select") {
            setBankSelected(null)
        }
        else {

            setBankSelected(event.target.value);
        }
    };

    const handleDateChange = (event) => {
        setStatementDate(event.target.value);
    };

   
    
    // Current date
    const currentDate = new Date();
    const formattedCurrentDate = formatDate(currentDate);
    
    // One day before the current date
    const oneDayBefore = new Date();
    oneDayBefore.setDate(oneDayBefore.getDate() - 1);
    const formattedOneDayBefore = formatDate(oneDayBefore);

    const handleSubmit = () => {

        if (!BankSelected) {
            props.handleAlertOpen("Please select a bank", "error")
        }
        else if(!statementDate){
            props.handleAlertOpen("Please select a statement date", "error")
        }
        
        else if (!file) {
            props.handleAlertOpen("Please upload a file", "error")
        }
        else if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
            props.handleAlertOpen("Please upload a valid Excel file (.xlsx or .xls)", "error");
        }
        else {
            HandleStatementUpload(file, BankSelected,statementDate, props.setIsLoading, props.handleAlertOpen, props.handleClose)
        }
    }

    useEffect(() => {
        setBankSelected(null)
        setFile(null)
        setStatementDate(formatDate(new Date()))
    }, [props.open])


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <Box sx={{ position: 'absolute', top: 10, right: 10, fontSize: '18px', cursor: 'pointer' }} onClick={props.handleClose}>
                    <IoMdClose />
                </Box>
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'> {"Upload File"}</Typography>
                </DialogTitle>
                <DialogContent >
                    <Stack direction="column" gap={1} justifyContent="flex-start" alignItems="flex-start">
                        <FormControl fullWidth size='small' sx={{ marginTop: 1 }}>
                            <InputLabel id="demo-simple-select-label">Bank</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={BankSelected ? BankSelected : "Select"}
                                label="Bank"
                                onChange={(e) => handleChange(e)}
                                size='small'
                            >
                                <MenuItem value={"Select"}>Select</MenuItem>
                                <MenuItem value={"sbi"}>SBI</MenuItem>
                                <MenuItem value={"icici"}>ICICI</MenuItem>
                                <MenuItem value={"hdfc"}>HDFC</MenuItem>
                                <MenuItem value={"axis"}>AXIS</MenuItem>
                                <MenuItem value={"bob"}>BOB</MenuItem>

                            </Select>
                        </FormControl>
                        <Stack direction="row" justifyContent="flex-start" alignItems="center" width="100%" gap={1}>
                            <TextField
                                id="outlined-basic"
                                label="Date"
                                variant="outlined"
                                fullWidth
                                type='date'
                                size='small'
                                value={statementDate}
                                onChange={handleDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                    
                                   }}
                                inputProps={{
                                    max:formattedCurrentDate,
                                    min:formattedOneDayBefore,
                                    onKeyDown: (e) => e.preventDefault(),
                                    style: {
                                      textAlign: 'left',
                                    }
                                }}
                            />

                            <Button
                                component="label"
                                role={undefined}
                                variant="outlined"
                                color='secondary'
                                tabIndex={-1}
                                size='small'
                            >
                                {
                                    file ? "Uploaded" : "Upload"
                                }

                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={(event) => handleFileUpload(event)}
                                    multiple
                                />
                            </Button>
                        </Stack>
                    </Stack>

                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant='contained' disabled={props.isLoading ? true : false} color='secondary' onClick={() => handleSubmit()}>{props.isLoading ? "Loading..." : "Submit"}</Button>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
